<template>
  <div class="footBox">
    <div class="foot">
      <div class="left">
        <div class="top">
          <div class="contact">
            <div class="name">联系电话: {{webInfo.phone3}}</div>
            <div class="name">邮箱: {{webInfo.email}}</div>
            <div class="name">地址：{{webInfo.address}}</div>
          </div>
          <div style="position: relative">
            <div class="yfhcode">
              <div class="qrwx">
                <img :src="webInfo.qrcodeUrl" alt="" />
              </div>
              <div class="name" style="margin-top: 10px">微信公众号</div>
            </div>
          </div>

          <div class="contact">
            <div class="name">技术支持：河北中惠博裕科技有限公司</div>
            <div class="name">联系电话: 400-780-9998</div>
            <div class="name">邮箱: zhby@qq.com</div>
            <div class="name">地址: 河北省石家庄市桥西区中山东路126号凯嘉大厦10楼</div>
          </div>
        </div>
        <div class="bottom">
          <div class="copy-right">
            <a target="_blank" href="https://beian.miit.gov.cn/" class="item">
              {{webInfo.webBah}}
            </a>
            <a
              v-if="webInfo.webWah"
              :href="'http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=' + webInfo.webWah.match(/\d+/)[0]"
              rel="noreferrer"
              target="_blank"
              class="item"
            >
              <img src="~/assets/images/gongan.png" style="width: 16px; position: relative; top: 3px"/>
              {{webInfo.webWah}}
            </a>
            <span class="item">|</span>
            <span class="item">@2019</span>
            <span class="item">{{webInfo.webBqsm}}</span>
          </div>
        </div>
      </div>
      <div style="position: relative">
        <div class="right">
          <div class="list">
            <div class="item" v-for="(item, index) in qrcodeList" :key="index">
              <div class="qrcode">
                <img :src="item.img" alt="" />
              </div>
              <div class="name">{{ item.name }}</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
   inject: ['webInfo'],
  name: "Footer",
  data() {
    return {
      qrcodeList: [
        {
          img: require("~/assets/hzb.png"),
          name: "惠招标微信公众号",
        },
        {
          img: require("~/assets/hzbdy.png"),
          name: "惠招标抖音号",
        },
      ],
    };
  },
  mounted() {},
  methods: {
    // 导航切换
    handleSelect(keyPath, type) {
      if (type == "system") {
        //跳转网站外部链接
        window.open(keyPath, "_blank");
      } else {
        let path = "/";
        path += keyPath;
        this.$router.push({
          path,
        });
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.footBox {
  width: 100%;
  /* margin-top: 30px; */
  padding: 40px 0 50px 0;
  color: #fff;
  background-color: #040b1f; /* #2f354d; */
  border-top: 1px solid #4b4b4b;
}
.foot {
  width: 1200px;
  margin: 0 auto;
  display: flex;
  /* justify-content: space-between; */
}
.left {
  width: 80%;
}
.top {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
}
.websites {
  width: 40%;
  margin-top: 30px;
}
.websites-top {
  display: flex;
  justify-content: space-between;
}
.top .title {
  font-size: 18px;
  line-height: 46px;
}
.top .name {
  color: #b4b6bc;
  display: block;
  /* line-height: 46px; */
  font-size: 15px;
}
.top .names {
  color: #fff;
  line-height: 46px;
  font-size: 14px;
}
.contact {
  width: 40%;
  /* margin-top: 15px; */
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  height: 160px;
}
.left .bottom {
  border-top: 1px solid #7d7d7d;
  margin-top: 30px;
  width: fit-content;
}
.bottom .copy-right {
  line-height: 30px;
  overflow: hidden;
  padding-top: 20px;
}
.copy-right .item {
  position: relative;
  color: #b4b6bc;
  font-size: 15px;
}
.copy-right .item + .item {
  margin-left: 1em;
}
.item .record {
  display: inline-block;
  height: 19px;
}
.right {
  /* width: 10%; */
  position: absolute;
  /* right: 18%;
  bottom: 23%; */
  right: -190px;
}
.list {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  /* margin-top: 30px; */
  /* flex-direction: column; */
  width: max-content;
}
.right .item {
  /* width: 50%; */
  display: flex;
  flex-flow: column;
  align-items: center;
  margin-bottom: 30px;
  padding-right: 45px;
}
.qrcode {
  width: 86px;
  height: 86px;
}
.qrcode img {
  width: 86px;
}
.item .name {
  line-height: 1em;
  margin-top: 10px;
  font-size: 15px;
  color: #b4b6bc;
}

.yfhcode {
  /* width: 25%; */
  /* width: 10%; */
  /* margin-top: 40px; */
  text-align: center;
  position: absolute;
  bottom: 44px;
  left: -200px;
}
.qrwx {
  height: 86px;
}
.qrwx img {
  /* height:86px; */
  width: 86px;
}
.webicon {
  margin-bottom: 10px;
}
.logoImg {
  width: auto;
  height: 45px;
}
</style>
